module.exports = __webpack_public_path__ + "static/media/U1-T1-08D_R.81d4cbc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-08D_R.svg
// module id = 587
// module chunks = 0